import Label from '@components/obsolete/Form/Label/Label.tsx';

interface ComponentProps {
  title?: any;
  children?: any;
  dataTestId?: string;
}

const InfoProvidedItem: React.FC<ComponentProps> = ({ title, children, dataTestId }) => {
  return (
    <div className="info-provided-item" data-testid={dataTestId}>
      <Label title={title} />
      <div className="info-provided-item__description">{children}</div>
    </div>
  );
};
export default InfoProvidedItem;
